import React from "react";
import UnderlineTabs from "@/components/UnderlineTabs";
import { WANT_LISTING_STATUSES } from "@/helpers/wantListingStatus";

export const EXPIRING_SOON_TAB = { key: "expiring", label: "Expiring soon" };

const withExpiring = (statuses) =>
  statuses.flatMap((status) => (status.key === "active" ? [status, EXPIRING_SOON_TAB] : [status]));

export const STATUS_TABS = [{ key: "all", label: "All" }, ...withExpiring(WANT_LISTING_STATUSES)];

const WantAdStatusTabs = ({ value, onChange }) => (
  <UnderlineTabs tabs={STATUS_TABS} value={value} onChange={onChange} label="Status" />
);

export default WantAdStatusTabs;
